export default __webpack_public_path__ + "static/media/fork.0dba07b6.svg";